<template>
  <v-dialog
    max-width="950"
    v-model="isOpen"
    persistent
    @keydown.esc="isOpen=false"
  >
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step
          :complete="step > 1"
          step="1"
        >
          Subir factura
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="step > 2"
          step="2"
        >
          Actualizar productos
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          step="3"
          :complete="step > 3">
          Productos nuevos
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4">
          Crear productos
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card>
          <v-card-text>
            <v-form ref="formStep1" v-model="formStep1">
              <v-file-input
                v-model="file"
                dense
                rounded
                outlined
                hide-details
                label="Subir archivo"
                accept=".xml"
                :rules="rules.required"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />

            <v-btn
              text
              rounded
              @click="close">
              Cancelar
            </v-btn>

            <v-btn
              color="primary"
              rounded
              depressed
              @click="uploadFile"
            >
              Subir archivo
            </v-btn>
          </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card>
            <v-card-text>
              <div v-if="foundProducts.length">
                <v-simple-table class="elevation-1">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Producto
                        </th>
                        <th class="text-left">
                          Unidad y precio de factura
                        </th>
                        <th class="text-left">
                          Datos del producto
                        </th>
                        <th class="text-left">
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in foundProducts"
                        :key="`found-${index}`"
                      >
                        <td>{{ item.name }}</td>
                        <td>
                          <div v-if="getUnitName(item.unit)">
                            {{ getUnitName(item.unit) }}
                          </div>
                          <div v-else class="caption">
                            Unidad de medida no encontrada <br>
                            <span class="red--text"> Clave unidad: {{ item.unit }} </span>
                          </div>
                          <div>
                            {{ castNumber(item.amountInvoice) | toFixNumber(2) | numberWithComma | prefix('$') }}
                          </div>
                        </td>
                        <td>
                          <div class="d-flex py-1">
                            <div>
                              <div class="mr-1 mb-2">
                                <v-text-field
                                  label="Marca"
                                  dense
                                  rounded
                                  outlined
                                  hide-details
                                  v-model="item.brand"
                                  >
                                </v-text-field>
                              </div>
                              <div class="mr-1 mb-2">
                                <v-autocomplete
                                  v-model="item.contentUnit"
                                  label="Unidad de contenido"
                                  :rules="rules.required"
                                  :items="units"
                                  :filter="filterUnit"
                                  item-text="name"
                                  item-value="_id"
                                  hide-details
                                  dense
                                  rounded
                                  outlined>
                                </v-autocomplete>
                              </div>
                              <div class="mr-1 mb-2">
                                <v-text-field
                                  v-model.number="item.amount"
                                  dense
                                  rounded
                                  outlined
                                  hide-details
                                  prefix="$"
                                  label="Monto"
                                  :rules="rules.amount"
                                  @blur="updateProfitProductsUpdate(item, index)"
                                />
                              </div>
                            </div>
                            <div>
                              <div class="mr-1 mb-2">
                                <v-text-field
                                  v-model.number="item.contentQuantity"
                                  dense
                                  rounded
                                  outlined
                                  hide-details
                                  :rules="rules.contentQuantity"
                                  label="Cantidad de contenido">
                                  <template v-slot:append>
                                    <v-tooltip
                                      max-width="200"
                                      left>
                                      <template v-slot:activator="{ on }">
                                        <v-btn
                                          v-on="on"
                                          color="primary"
                                          icon
                                          x-small
                                          depressed
                                        >
                                          <v-icon>mdi-help</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>
                                        La cantidad de contenido es qué tanto tiene esa presentación que vendes, por ejemplo si es 1 Caja, pero contiene 10 paquetes.
                                      </span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </div>
                              <div class="mr-1 mb-2">
                                <v-select
                                  v-model="item.category"
                                  dense
                                  rounded
                                  outlined
                                  hide-details
                                  label="Categoría"
                                  :items="categories"
                                  item-text="name"
                                  item-value="_id"
                                  :rules="rules.required"
                                />
                              </div>
                              <div class="mr-1 mb-2">
                                <v-text-field
                                  v-model.number="item.profit"
                                  dense
                                  rounded
                                  outlined
                                  hide-details
                                  prefix="%"
                                  label="Porcentaje de ganancia"
                                  :rules="rules.profit"
                                  @blur="updateAmountProductsUpdate(item, index)">
                                  <template v-slot:append>
                                    <v-tooltip
                                      max-width="200"
                                      left>
                                      <template v-slot:activator="{ on }">
                                        <v-btn
                                          v-on="on"
                                          color="primary"
                                          icon
                                          x-small
                                          depressed
                                        >
                                          <v-icon>mdi-help</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>
                                        Si la factura es de un proveedor tuyo, le aumentas un porcentaje para tener una ganancia del precio que te vende tu proveedor.
                                      </span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <v-btn
                            fab
                            x-small
                            depressed
                            color="error"
                            @click="removeFoundProducts(index)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
              <div v-else>
                No se encotraron productos para actualizar, en el siguiente paso se mostrarán los nuevos productos para crearlos.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />

              <v-btn
                text
                rounded
                @click="close">
                Cancelar
              </v-btn>

              <v-btn
                color="primary"
                rounded
                depressed
                @click="goStep3"
              >
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card>
            <v-card-text>
              <div v-if="newProducts.length">

                <v-form ref="formStep3" v-model="formStep3">
                  <v-simple-table class="elevation-1">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Producto
                          </th>
                          <th class="text-left">
                            Unidad y precio de factura
                          </th>
                          <th class="text-left">
                            Datos del producto
                          </th>
                          <th class="text-left">
                            Acción
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in newProducts"
                          :key="`new-${index}`"
                        >
                          <td>
                            <div v-if="getUnitName(item.unit)">
                              {{ item.name }}
                            </div>
                            <div v-else class="red--text">
                              {{ item.name }}
                            </div>
                          </td>
                          <td>
                            <div v-if="getUnitName(item.unit)">
                              {{ getUnitName(item.unit) }}
                            </div>
                            <div v-else class="caption">
                              Unidad de medida no encontrada <br>
                             <span class="red--text"> Clave unidad: {{ item.unit }} </span>
                            </div>
                            <div>
                              {{ castNumber(item.price) | toFixNumber(2) | numberWithComma | prefix('$') }}
                            </div>
                          </td>
                          <td>
                            <div class="d-flex py-1">
                              <div>
                                <div class="mr-1 mb-2">
                                  <v-select
                                    v-model="item.type"
                                    dense
                                    rounded
                                    outlined
                                    hide-details
                                    label="Tipo"
                                    :items="[
                                      { text: 'Producto', value: 'product' },
                                      { text: 'Servicio', value: 'service' }
                                    ]"
                                    item-text="text"
                                    item-value="value"
                                    :rules="rules.required"
                                  />
                                </div>
                                <div class="mr-1 mb-2">
                                  <v-text-field
                                    v-model.number="item.contentQuantity"
                                    dense
                                    rounded
                                    outlined
                                    hide-details
                                    :rules="rules.contentQuantity"
                                    label="Cantidad de contenido">
                                    <template v-slot:append>
                                      <v-tooltip
                                        max-width="200"
                                        left>
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                            v-on="on"
                                            color="primary"
                                            icon
                                            x-small
                                            depressed
                                          >
                                            <v-icon>mdi-help</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>
                                          La cantidad de contenido es qué tanto tiene esa presentación que vendes, por ejemplo si es 1 Caja, pero contiene 10 paquetes.
                                        </span>
                                      </v-tooltip>
                                    </template>
                                  </v-text-field>
                                </div>
                              </div>
                              <div>
                                <div class="mr-1 mb-2">
                                  <v-text-field
                                    label="Marca"
                                    dense
                                    rounded
                                    outlined
                                    hide-details
                                    v-model="item.brand"
                                    >
                                  </v-text-field>
                                </div>
                                <div class="mr-1 mb-2">
                                  <v-autocomplete
                                    v-model="item.contentUnit"
                                    label="Unidad de contenido"
                                    :rules="rules.required"
                                    :items="units"
                                    :filter="filterUnit"
                                    item-text="name"
                                    item-value="satCode"
                                    hide-details
                                    dense
                                    rounded
                                    outlined>
                                  </v-autocomplete>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div class="mr-1 mb-2">
                                <v-select
                                  v-model="item.category"
                                  dense
                                  rounded
                                  outlined
                                  hide-details
                                  label="Categoría"
                                  :items="categories"
                                  item-text="name"
                                  item-value="id"
                                  :rules="rules.required"
                                />
                              </div>
                            </div>
                          </td>
                          <td>
                            <v-btn
                              fab
                              x-small
                              depressed
                              color="error"
                              @click="removeProduct(index)">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-form>
              </div>
              <div v-else>
                No existen productos nuevos en la factura.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />

              <v-btn
                text
                rounded
                @click="close">
                Cancelar
              </v-btn>

              <v-btn
                v-if="newProducts.length"
                color="primary"
                rounded
                depressed
                @click="goStep4"
              >
                Continue
              </v-btn>

              <v-btn
                v-else
                color="primary"
                rounded
                depressed
                @click="close"
              >
                Finalizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-card>
            <v-card-text>
              <v-form ref="formStep4" v-model="formStep4">
                <v-simple-table v-if="productsToCreate.length">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Producto
                        </th>
                        <th class="text-left">
                          Unidad y precio de factura
                        </th>
                        <th class="text-left">
                          Marca
                        </th>
                        <th class="text-left">
                          Categoría
                        </th>
                        <th class="text-left">
                          Precio de venta
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in productsToCreate"
                        :key="`update-${index}`"
                      >
                        <td>{{ item.name }}</td>
                        <td>
                          <div v-if="differentUnit(item)">
                            {{ getUnitName(item.unit) }}
                            <div class="caption grey--text">
                              de {{ item.contentQuantity }} {{ getUnitName(item.contentUnit) }}
                            </div>
                          </div>
                          <div v-else>
                            {{ getUnitName(item.unit) }}
                          </div>
                          <div>
                            {{ castNumber(item.price) | toFixNumber(2) | numberWithComma | prefix('$') }}
                          </div>
                        </td>
                        <td>
                          {{ item.brand }}
                        </td>
                        <td>
                          {{ getCategoryName(item.category) }}
                        </td>
                        <td>
                          <div class="d-flex py-1">
                            <div class="mr-1 mb-2">
                              <v-text-field
                                v-model.number="item.amount"
                                dense
                                rounded
                                outlined
                                hide-details
                                prefix="$"
                                label="Monto"
                                :rules="rules.amount"
                                @blur="updateProfit(item, index)"
                              />
                            </div>
                            <div class="mr-1 mb-2">
                              <v-text-field
                                v-model.number="item.profit"
                                dense
                                rounded
                                outlined
                                hide-details
                                prefix="%"
                                label="Porcentaje de ganancia"
                                :rules="rules.profit"
                                @blur="updateAmount(item, index)">
                                <template v-slot:append>
                                  <v-tooltip
                                    max-width="200"
                                    left>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        color="primary"
                                        icon
                                        x-small
                                        depressed
                                      >
                                        <v-icon>mdi-help</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>
                                      Si la factura es de un proveedor tuyo, le aumentas un porcentaje para tener una ganancia del precio que te vende tu proveedor.
                                    </span>
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />

              <v-btn
                text
                rounded
                @click="close">
                Cancelar
              </v-btn>

              <v-btn
                color="primary"
                rounded
                depressed
                @click="submit"
              >
                Finalizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { taxes } from '@/utils/constants'

export default {
  data () {
    return {
      isOpen: false,
      overlay: false,
      step: 1,
      file: null,
      foundProducts: [],
      newProducts: [],
      productsToCreate: [],
      formStep1: false,
      formStep3: false,
      formStep4: false,
      rules: {
        required: [v => !!v || this.$t('validations.required')],
        contentQuantity: [
          v => !!v || this.$t('validations.required'),
          v => /^[0-9.]+$/.test(v) || 'Only numbers'
        ],
        amount: [
          v => !!v || this.$t('validations.required'),
          v => /^[0-9.]+$/.test(v) || 'Only numbers'
        ],
        profit: [
          v => !!v || this.$t('validations.required'),
          v => /^[0-9.-]+$/.test(v) || 'Only numbers'
        ]
      },
      taxes
    }
  },
  computed: {
    categories () {
      return this.$store.state.categories
    },
    units () {
      return this.$store.state.login.units.data
    }
  },
  methods: {
    removeFoundProducts (index) {
      this.foundProducts.splice(index, 1)
    },
    removeProduct (index) {
      this.newProducts.splice(index, 1)
      this.productsToCreate.splice(index, 1)
    },
    differentUnit (item) {
      return item.unit && item.contentUnit && item.unit.toLowerCase() !== item.contentUnit.toLowerCase()
    },
    open () {
      this.isOpen = true
    },
    close () {
      this.reset()
      this.isOpen = false
    },
    reset () {
      if (this.$refs.formStep1) this.$refs.formStep1.resetValidation()
      if (this.$refs.formStep3) this.$refs.formStep3.resetValidation()
      if (this.$refs.formStep4) this.$refs.formStep4.resetValidation()

      this.file = null
      this.foundProducts = []
      this.newProducts = []
      this.productsToCreate = []
      this.step = 1
    },
    async updateFoundProducts () {
      this.overlay = true
      try {
        await this.$api.put('/v1/catalog/pricing', this.foundProducts, { timeout: 120000 })
        this.step = 3
        this.addProdcutsToUpdate(this.newProducts)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async submit () {
      if (this.$refs.formStep4.validate()) {
        this.overlay = true
        const payload = this.productsToCreate.map(product => {
          return {
            name: product.name,
            satCode: product.satCode,
            category: product.category,
            type: product.type,
            brand: product.brand,
            amount: Number(product.amount),
            amountInvoice: Number(product.price),
            profit: Number(product.profit),
            displayUnit: this.getUnitId(product.unit),
            contentQuantity: Number(product.contentQuantity),
            contentUnit: this.getUnitId(product.contentUnit),
            taxes: product.taxes.map(prodTax => {
              const tax = this.taxes.find(tax => {
                const compare = new RegExp(tax.name, 'gi')
                return compare.test(prodTax.name)
              })
              return Object.assign({}, prodTax, { satCode: tax.satId })
            })
          }
        })
        try {
          await this.$api.post('/v1/catalog/pricing', payload)
          this.$toasted.show('Los productos se crearon correctamente', { duration: 3000 })
          this.$emit('updated')
          this.close()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async uploadFile () {
      if (this.$refs.formStep1.validate()) {
        this.overlay = true
        try {
          const response = await this.$api.post('/v1/catalog/pricing/upload', { xmlFile: this.file }, { delivery: 'formData' })
          this.foundProducts = response.update.map(prod => {
            const profit = prod.profit || 10
            const amount = this.calculateAmount(profit, prod.amountInvoice)
            return Object.assign(prod, { amount: Number(amount) })
          })
          this.newProducts = response.notFound.map(x => ({ ...x, price: x.amount }))
          this.goStep2()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    getUnitId (satCode) {
      if (satCode) {
        const unit = this.units.find(unit => {
          const unitSatCode = (unit && unit.satCode) ? unit.satCode.toLowerCase() : ''
          return unitSatCode === satCode.toLowerCase()
        })
        return unit ? unit.id : ''
      }
      return ''
    },
    getUnitName (satCode) {
      if (satCode) {
        const unit = this.units.find(unit => {
          const unitSatCode = (unit && unit.satCode) ? unit.satCode.toLowerCase() : ''
          return unitSatCode === satCode.toLowerCase()
        })
        return unit ? unit.name : ''
      }
      return ''
    },
    getCategoryName (categoryId) {
      const category = this.categories.find(category => category.id === categoryId)
      return category ? category.name : ''
    },
    goStep2 () {
      this.step = 2
    },
    async goStep3 () {
      await this.updateFoundProducts()
    },
    goStep4 () {
      if (this.$refs.formStep3.validate()) {
        const notFoundUnits = this.productsToCreate.filter(product => !this.getUnitId(product.unit) || !this.getUnitId(product.unit))
        if (notFoundUnits.length) {
          this.$toasted.show(`Algunas unidades de medida no estan registradas en el catálogo, para continuar deberá registrarlas.`, { duration: 3000 })
        } else {
          this.step = 4
        }
      }
    },
    addProdcutsToUpdate (products) {
      this.productsToCreate.push(...products.map(prod => {
        const profit = prod.profit || 10
        const amount = this.calculateAmount(profit, prod.price)
        return Object.assign(
          prod,
          {
            amount: amount,
            profit: profit
          }
        )
      }))
    },
    calculatePercentage (amountInvoice, amount) {
      const profit = amount - amountInvoice
      const percentage = (profit * 100) / amountInvoice
      return percentage
    },
    calculateAmount (profit, amountInvoice) {
      const rate = (profit || 0) / 100
      const amount = amountInvoice + (amountInvoice * rate)
      return Number(amount).toFixed(2)
    },
    updateProfitProductsUpdate (product, index) {
      const products = [...this.foundProducts]
      const profit = this.calculatePercentage(product.amountInvoice, product.amount)
      products[index] = {
        ...product,
        profit: profit
      }
      this.foundProducts = products
    },
    updateAmountProductsUpdate (product, index) {
      const products = [...this.foundProducts]
      const amount = this.calculateAmount(product.profit, product.amountInvoice)
      products[index] = {
        ...product,
        amount: amount
      }
      this.foundProducts = products
    },
    updateProfit (product, index) {
      const products = [...this.productsToCreate]
      const profit = this.calculatePercentage(product.price, product.amount)
      products[index] = {
        ...product,
        profit: profit
      }
      this.productsToCreate = products
    },
    updateAmount (product, index) {
      const products = [...this.productsToCreate]
      const amount = this.calculateAmount(product.profit, product.price)
      products[index] = {
        ...product,
        amount: amount
      }
      this.productsToCreate = products
    },
    filterUnit (item, queryText, itemText) {
      const a = new RegExp(queryText, 'gi')
      if (a.test(itemText)) {
        return item
      }
    },
    castNumber (number) {
      return Number(number)
    }
  }
}
</script>
